import { Injectable } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class ValidationService
{

  constructor() { }

  onlyNumbers(event:any)
  {
    var theEvent = event || window.event;
    var key = theEvent.keyCode || theEvent.which;
    key = String.fromCharCode(key);
    var regex = /[0-9]/;

    if (!regex.test(key))
    {
      event.preventDefault();
    }
  }


  onlyNumbersWithDecimals(event:any)
  {
    var charCode = (event.which) ? event.which : event.keyCode
    /** this code is used if before decimal 5 digit will complete then append "." and after decimal point 5 block */

    // Avoid dot at first position & Allow only 1 decimal point ('.') ...
    // Char Code: 46=delete | Char Code: 48 to 57 = 0 Number to 9 number
    if ((charCode === 46 && event.target.value.length === 0) ||
      ((event.target.value.indexOf('.') !== -1) && (charCode < 48 || charCode > 57)) ||
      (charCode !== 46 && (charCode < 48 || charCode > 57)))
    {
      event.preventDefault();
    }
  }

  onlyNumbersWithDecimalThree(event:any)
  {
    let int_dp = this.getDPValue(event.target.value);
    var charCode = (event.which) ? event.which : event.keyCode
    /** this code is used if before decimal 5 digit will complete then append "." and after decimal point 5 block */
    if (event.target.value.length === 3 && event.target.value.indexOf('.') === -1)
    {
      event.target.value = event.target.value + '.';
    }
    else if (int_dp > 4) // This validation is applicable in case of decimal(10,5) in database field
    {
      event.preventDefault();
    }
    // Avoid dot at first position & Allow only 1 decimal point ('.') ...
    // Char Code: 46=delete | Char Code: 48 to 57 = 0 Number to 9 number
    if ((charCode === 46 && event.target.value.length === 0) ||
      ((event.target.value.indexOf('.') !== -1) && (charCode < 48 || charCode > 57)) ||
      (charCode !== 46 && (charCode < 48 || charCode > 57)))
    {
      event.preventDefault();
    }
  }

  onlyNumbersWithDecimal(event:any)
  {
    if((Number(event.target.value)<= 0.00001 && Number(event.target.value)!=0) || Number(event.target.value)>= 99999.99999 || event.target.length>=11)
    {
       event.preventDefault();
    }
    else
    {
      let int_dp = this.getDPValue(event.target.value);
      var charCode = (event.which) ? event.which : event.keyCode
      /** this code is used if before decimal 5 digit will complete then append "." and after decimal point 5 block */
      if (event.target.value.length === 5 && event.target.value.indexOf('.') === -1)
      {
        event.target.value = event.target.value + '.';
      }
      else if (int_dp > 4) // This validation is applicable in case of decimal(10,5) in database field
      {
        event.preventDefault();
      }
      // Avoid dot at first position & Allow only 1 decimal point ('.') ...
      // Char Code: 46=delete | Char Code: 48 to 57 = 0 Number to 9 number
      if ((charCode === 46 && event.target.value.length === 0) ||
        ((event.target.value.indexOf('.') !== -1) && (charCode < 48 || charCode > 57)) ||
        (charCode !== 46 && (charCode < 48 || charCode > 57)))
      {
        event.preventDefault();
      }
    }
  }

  validateOnlyWhiteSpaceEnter(control: AbstractControl)
  {
    if (control.value)
    {
      if (control.value.trim().length == 0)
      {
        return { required: 'Required' };
      }
    }

    return null;
  }

  requiredField(control: AbstractControl)
  {
  //  console.log("requiredField control.value",control.value);
    if (control.value == null || control.value === "")
    {
     // console.log(" if control.value",control.value);
      //console.log(" control.value == null",control.value == null);
     // console.log(" control.value ==  ",control.value == "");

      return { required: 'Required' };
    }

    return null;
  }

  getDPValue(value: any)
  {
    var int_dp;

    if (value != null && value.indexOf('.') !== -1)
    {
      int_dp = value.split(".");
    }
    else
    {
      return 0;
    }

    if (int_dp[1] == undefined)
    {
      return 0;
    }
    else
    {
      return int_dp[1].length;
    }
  }

  validateZeroEntry(control: AbstractControl)
  {
    const isZeroEntry = null;
    if (control.value != null && control.value <= 0 && control.value.length != 0)
    {
      return { isZeroEntry: ' Greater Than Zero' };
    }
    return isZeroEntry;

  }

  stdT1PosT1NegT2NegT2PosValCmpValidator(compControlName: string, paramType: string, cmpTol: string, tolType: string, cmpTolSame: string,
    limitOnControlName: any)
  {


    let currControl: FormControl;
    let compControl: FormControl;
    let limitControl: FormControl;



    return function controlValidate(control: FormControl)
    {

      if (!control.parent)
      {
        return null;
      }

      // Initializing the validator.
      if (!currControl)
      {

        currControl = control;
        compControl = control.parent.get(compControlName) as FormControl;
        limitControl = control.parent.get(limitOnControlName) as FormControl;

        if (!compControl)
        {
          throw new Error(
            "controlValidate(): other control is not found in parent group"
          );
        }

        compControl.valueChanges.subscribe((res) =>
        {
          currControl.updateValueAndValidity();
        });
      }

      if ((
        paramType == "Group" || paramType == "Individual" ||
        paramType == "Group Layer1" || paramType == "Individual Layer1" ||
        paramType == "Individual Layer2" || paramType == "Group Layer2" ||
        paramType == "Dimension" || paramType == "Content1" || paramType == "Content2" || paramType == "Content3" || paramType == "Content4"
      ) &&
        (tolType == "Positive" || tolType == "Negative") &&
        (cmpTol == "2" || cmpTol == "1") &&
        (cmpTolSame == "No")
      )
      {

        if (Number(compControl.value) >= Number(currControl.value) &&
          Number(compControl.value != '') && Number(currControl.value != '') &&
          Number(compControl.value != 0) && Number(currControl.value != 0) &&
          Number(compControl.value != null) && Number(currControl.value != null))
        {

          return {
            cmpMsg: "Tolerance 2 " + tolType + " Value cannot be Less Than or Equal to Tolerance 1 " + tolType + " Value"
          };

        }

        else
        {
          return null;
        }
      }

      if ((
        paramType == "Group" || paramType == "Individual" ||
        paramType == "Group Layer1" || paramType == "Individual Layer1" ||
        paramType == "Individual Layer2" || paramType == "Group Layer2" ||
        paramType == "Dimension" || paramType == "Content1" || paramType == "Content2" || paramType == "Content3" || paramType == "Content4"
      ) &&
        (tolType == "NMT") && (cmpTol == "1") && (cmpTolSame == "No")
      )
      {

        if (Number(compControl.value) == 0 && Number(currControl.value) > Number(compControl.value))
        {

          return {
            cmpMsg: "Enter Tolerance1 Value Greater Than Zero"
          };

        }

        else
        {
          return null;
        }
      }

      if (
        (
          paramType == "Group" || paramType == "Individual" ||
          paramType == "Group Layer1" || paramType == "Individual Layer1" ||
          paramType == "Individual Layer2" || paramType == "Group Layer2" ||
          paramType == "Dimension" || paramType == "Content1" || paramType == "Content2" || paramType == "Content3" || paramType == "Content4"
        ) &&
        (tolType == "Positive" || tolType == "Negative") &&
        (cmpTol == "2" || cmpTol == "1") &&
        (cmpTolSame == "Std")
      )
      {

        // if (Number(currControl.value) >= Number(compControl.value) && limitControl.value == "Actual")
        if (Number(currControl.value) >= Number(compControl.value) && limitControl.value == "Actual" && Number(currControl.value) != 0)
        {

          return {
            cmpMsg: "Tolerance " + cmpTol + " " + tolType + " Value cannot be Greater Than or Equal to Std. Value "
          };

        }

        else
        {
          return null;
        }
      }

      if (
        (
          paramType == "Group" || paramType == "Individual" ||
          paramType == "Group Layer1" || paramType == "Individual Layer1" ||
          paramType == "Individual Layer2" || paramType == "Group Layer2" ||
          paramType == "Dimension" || paramType == "Content1" || paramType == "Content2" || paramType == "Content3" || paramType == "Content4"
        ) &&
        (tolType == "Positive" || tolType == "Negative") && (cmpTol == "1" || cmpTol == "2") &&
        (cmpTolSame == "Zero"))
      {

        if (((Number(compControl.value) != 0) && (Number(currControl.value) == 0)) &&
          Number(compControl.value != '') && Number(currControl.value != '') &&
          Number(compControl.value != null) && Number(currControl.value != null))
        {
          return {
            cmpMsg: "Enter Tolerance" + cmpTol +" Value Greater Than Zero"
          };
        }

        else
        {
          return null;
        }
      }

      if (paramType == "Hardness" || paramType == "Moisure Analyzer")
      {

        if (cmpTol == "2" &&
          Number(currControl.value) == 0 && Number(compControl.value) == 0 &&
          Number(compControl.value != '') && Number(currControl.value != '') &&
          Number(compControl.value != null) && Number(currControl.value != null))
        {

          if (paramType == "Hardness")
          {
            return {
              cmpMsg: "Enter NLT and NMT Greater Than Zero"
            };
          }
          else
          {
            return {
              cmpMsg: "Enter NLT(%W/W) And NMT(%W/W) Greater Than Zero"
            };
          }

        }

        if (cmpTol == "2" && Number(compControl.value) >= Number(currControl.value) &&
          Number(compControl.value != '') && Number(currControl.value != '') &&
          Number(compControl.value != 0) && Number(currControl.value != 0) &&
          Number(compControl.value != null) && Number(currControl.value != null) &&
          (cmpTolSame == "No"))
        {

          if (paramType == "Hardness")
          {
            return {
              cmpMsg: "NLT cannot be Greater Than or Equal to NMT"
            };
          }
          else
          {
            return {
              cmpMsg: "NLT(%W/W) cannot be Greater Than or Equal to NMT(%W/W)"
            }
          }

        }

        if (cmpTol == "2" && Number(currControl.value) <= Number(compControl.value) &&
          Number(compControl.value != '') && Number(currControl.value != '') &&
          Number(compControl.value != 0) && Number(currControl.value != 0) &&
          Number(compControl.value != null) && Number(currControl.value != null) &&
          (cmpTolSame == "Std") && tolType == "Positive")
        {

          if (paramType == "Hardness")
          {
            return {
              cmpMsg: "NMT cannot be Less Than or Equal to Std. Value"
            };
          }

        }

        if (cmpTol == "2" && Number(currControl.value) >= Number(compControl.value) &&
          Number(compControl.value != '') && Number(currControl.value != '') &&
          Number(compControl.value != 0) && Number(currControl.value != 0) &&
          Number(compControl.value != null) && Number(currControl.value != null) &&
          (cmpTolSame == "Std") && tolType == "Negative")
        {

          if (paramType == "Hardness")
          {
            return {
              cmpMsg: "NLT cannot be Greater Than or Equal to Std. Value"
            };
          }

        }





        else
        {
          return null;
        }
      }

      if (paramType == "Disintegration Test")
      {

        // compControl.valueChanges.subscribe((res) =>
        // {
        //   currControl.updateValueAndValidity();
        // });

        let int_DTHHTime: number = 0;
        let int_DTHHTimeCoat: number = 0;

        if (control.root.get('int_DTHHTime'))
        {
          int_DTHHTime = control.root.get('int_DTHHTime')?.value;
        }
        else
        {
          int_DTHHTime = 0;
        }

        if (control.root.get('int_DTHHTimeCoat'))
        {
          int_DTHHTimeCoat = control.root.get('int_DTHHTimeCoat')?.value;
        }
        else
        {
          int_DTHHTimeCoat = 0;
        }

        if (cmpTol == "1" && compControlName == "int_DTMMTime" &&
          Number(currControl.value) == 0 && Number(compControl.value) == 0 && (int_DTHHTime == 0) &&
          Number(compControl.value != '') && Number(currControl.value != '') &&
          Number(compControl.value != null) && Number(currControl.value != null) && (int_DTHHTime != null))
        {
          return {
            cmpMsg: "Enter DT Time Value Greater Than Zero"
          };
        }

        if (cmpTol == "1" && compControlName == "int_DTMMTimeCoat" &&
          Number(currControl.value) == 0 && Number(compControl.value) == 0 && (int_DTHHTimeCoat == 0) &&
          Number(compControl.value != '') && Number(currControl.value != '') &&
          Number(compControl.value != null) && Number(currControl.value != null) && (int_DTHHTimeCoat != null))
        {
          return {
            cmpMsg: "Enter DT Time Value Greater Than Zero"
          };
        }

        if (cmpTol == "2" && Number(compControl.value) >= Number(currControl.value) &&
          Number(compControl.value != '') && Number(currControl.value != '') &&
          Number(compControl.value != 0) && Number(currControl.value != 0) &&
          Number(compControl.value != null) && Number(currControl.value != null))
        {
          return {
            cmpMsg: "Min Temp cannot be Greater Than or Equal to Max Temp"
          };
        }

        else
        {
          return null;
        }
      }

      if (paramType == "Tapped Density" || paramType == "Sieve Shaker" ||
        paramType == "LOD Compressed Dry" || paramType == "LOD Compressed Lubricated" || paramType == "LOD Layer1 Dry"
        || paramType == "LOD Layer 1 Lubricated" || paramType == "LOD Layer2 Dry" || paramType == "LOD Layer 2 Lubricated"
        || paramType == "Tap Density" || paramType == "% Fine" || paramType == "Particle Sizing" || paramType == "Bulk Density")
      {

        if (cmpTol == "1" && Number(compControl.value) >= Number(currControl.value) &&
          Number(compControl.value != '') && Number(currControl.value != '') &&
          // Number(compControl.value != 0) && Number(currControl.value != 0) &&
          Number(compControl.value != null) && Number(currControl.value != null))
        {

          if (paramType == "Tapped Density" || paramType == "Bulk Density")
          {
            return {
              cmpMsg: "Max(gm/ml) cannot be Less Than or Equal to Min(gm/ml)"
            };
          }
          else if (paramType == "% Fine" || paramType == "Particle Sizing")
          {
            return {
              cmpMsg: "Max(%) cannot be Less Than or Equal to Min(%)"
            }
          } else
            return {
              cmpMsg: "Max(%W/W) cannot be Less Than or Equal to Min(%W/W)"
            };
        }

        else
        {
          return null;
        }
      }
      return null;

    };
  }

  allowCharactersInInputFields(event:any)
  {
    var theEvent = event || window.event;
    var key = theEvent.keyCode || theEvent.which;
    key = String.fromCharCode(key);
    var regex = /[A-Za-z0-9\s$!()@%&^<>#.:/_-]/;
    if (!regex.test(key))
    {
      theEvent.returnValue = false;
      if (theEvent.preventDefault) theEvent.preventDefault();
    }
  }

  //user can enter comma (,) for MVL-CR-013
  allowCharactersAndCommasInInputFields(event:any)
  {
    var theEvent = event || window.event;
    var key = theEvent.keyCode || theEvent.which;
    key = String.fromCharCode(key);
    var regex = /[A-Za-z0-9,\s$!()@%&^<>#.:/_-]/;
    if (!regex.test(key))
    {
      theEvent.returnValue = false;
      if (theEvent.preventDefault) theEvent.preventDefault();
    }
  }

  allowCharactersInInputFieldsExceptSpecialChr(event:any)
  {
    var theEvent = event || window.event;
    var key = theEvent.keyCode || theEvent.which;
    key = String.fromCharCode(key);
    var regex = /[A-Za-z0-9\s]/;
    if (!regex.test(key))
    {
      theEvent.returnValue = false;
      if (theEvent.preventDefault) theEvent.preventDefault();
    }
  }
  checkForEmptyAndIndStd(compControlName:any)
  {
    let currControl: FormControl;
    let compControl: FormControl;
    return function controlValidate(control: FormControl)
    {
      if (!control.parent)
      {
        return null;
      }

      // Initializing the validator.
      if (!currControl)
      {

        currControl = control;
        compControl = control.parent.get(compControlName) as FormControl;

        if (!compControl)
        {
          throw new Error(
            "controlValidate(): other control is not found in parent group"
          );
        }

        compControl.valueChanges.subscribe((res) =>
        {
          currControl.updateValueAndValidity();
        });
      }

      if (Number(compControl.value) < Number(currControl.value))
      {
        return {
          EmptyMsg: "Empty Std. Value Less Than Filled Std. Value"
        };
      } else
      {
        return null
      }

    }
  }
}
